import { GridRowParams } from "@mui/x-data-grid";
import { UseRecordsOptions } from "../api/useRecords";
import { RecordContextType } from "../components/record/Record";

export const processesOptions = {
  groupsOptions: {
    fieldsWithExtraOptions: [
      {
        field: "process_category",
        enabled: true,
      },
      {
        field: "responsibles_role",
        relatedTable: "directus_roles",
        displayTemplate: "{{name}}",
        enabled: true,
        sort: "name",
      },
      {
        field: "supervisores_role",
        relatedTable: "directus_roles",
        displayTemplate: "{{name}}",
        enabled: true,
        sort: "name",
      },
      {
        field: "shared_roles",
        relatedTable: "directus_roles",
        displayTemplate: "{{name}}",
        enabled: true,
        sort: "name",
      },
    ],
    navigateAfterUpdate: (arg: any) => createUrlForUpdate(arg),
    navigateAfterCreate: (arg: any) => createUrlForCreate(arg),
  },
  dataGridOptions: {
    navigateToDetail: (arg: GridRowParams<any>) => createUrlForDetail(arg),
  },
  createRelatedParams: (params: RecordContextType | undefined) => createProcessParams(params),
} as unknown as UseRecordsOptions;

const createUrlForUpdate = (arg: any) => {
  const parentCategoryId = arg.recordContext.item.process_category.process_parent_category;
  const childCategoryId = arg.recordContext.item.process_category.id;
  const processId = arg.id;

  return `/processes/parentcategory/${parentCategoryId}/category/${childCategoryId}/${processId}`;
};

const createUrlForCreate = (arg: any) => {
  return `/process_category/${arg.data.process_category}/processes`;
};

const createUrlForDetail = (arg: GridRowParams<any>) => {
  if (!arg?.row) return null;
  const parentCategoryId = arg.row.process_category?.process_parent_category;
  const childCategoryId = arg.row.process_category?.id;
  const processId = arg.row.id;

  return `/processes/parentcategory/${parentCategoryId}/category/${childCategoryId}/${processId}`;
};

const createProcessParams = async (recordContext: RecordContextType | undefined) => {
  if (!recordContext?.item) return;
  if (recordContext.entity === "process_category") {
    return `[process_category][id]=${recordContext.item.id}`;
  }
};
